var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-element",style:(_vm.styleObj)},[_c('div',{staticClass:"token"},[_vm._v(_vm._s(_vm.text)+_vm._s(_vm.item.id))]),_vm._v(" "),(_vm.item.collisions > 1)?_c('span',{staticClass:"collision-marker"},[_vm._v("\n    "+_vm._s(_vm.item.collisions)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa5c548","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/GridElement.vue
// module id = 25
// module chunks = 0